import z from "zod";

/**
 * Form schema for client export section selection
 */
export const ExportFormSchema = z.object({
  clientProfileSections: z.array(z.string()),
  problemsAllergiesMedicationsSections: z.array(z.string()),
  billingSections: z.array(z.string()),
  encounterIds: z.array(z.string()),
  intakeFormSections: z.array(z.string()),
  encounterFlowsheetIds: z.array(z.string()),
  labOrderIds: z.array(z.string()),
  fileIds: z.array(z.string()),
});

export type ExportFormSchemaType = z.infer<typeof ExportFormSchema>;
